'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _scales = require('./scales.json');

var _scales2 = _interopRequireDefault(_scales);

var _WindBarbsLegend = require('./WindBarbsLegend');

var _WindBarbsLegend2 = _interopRequireDefault(_WindBarbsLegend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChartLegend = function ChartLegend(_ref) {
  var type = _ref.type;
  var _scales$type = _scales2.default[type],
      blocks = _scales$type.blocks,
      labels = _scales$type.labels,
      unit = _scales$type.unit;


  var linearGradientSteps = blocks.reduce(function (accum, block, index, array) {
    var prevBlock = array[index - 1];
    if (index === 0) {
      return block.color + ' ' + block.position + '%, ';
    } else if (index < array.length - 1) {
      return accum + ' ' + block.color + ' ' + prevBlock.position + '%, ' + block.color + ' ' + block.position + '%, ';
    }
    return accum + ' ' + block.color + ' ' + prevBlock.position + '%';
  }, '');

  var linearGradient = 'linear-gradient(90deg, ' + linearGradientSteps + ')';

  return _react2.default.createElement(
    'div',
    { className: 'quiver-chart-legend' },
    _react2.default.createElement(
      'div',
      { className: 'quiver-chart-legend__labels' },
      _react2.default.createElement(
        'div',
        { className: 'quiver-chart-legend__units' },
        '(',
        unit,
        ')'
      ),
      labels.map(function (label) {
        return _react2.default.createElement(
          'div',
          {
            key: label.value,
            className: 'quiver-chart-legend__label',
            style: { right: 100 - label.position + '%' }
          },
          label.value
        );
      })
    ),
    _react2.default.createElement('div', {
      className: 'quiver-chart-legend__bar',
      style: { background: linearGradient }
    }),
    type === 'wind' ? _react2.default.createElement(_WindBarbsLegend2.default, null) : null
  );
};

ChartLegend.propTypes = {
  type: _propTypes2.default.string.isRequired
};

exports.default = ChartLegend;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/ChartLegend/ChartLegend.js
// module id = 552
// module chunks = 11